import moment from "moment";
import { invesment } from "../Utils/constants";

export const awsApiCotizacionRG = (values, assured, contratant, repLegal, uuid) => {

  let dateNow = moment().format("MM/DD/YYYY");
  let dateFormat = dateNow;
  const age = moment().diff(moment(values.birthday, "DD/MM/YYYY"), "years");

  let dateDevengueComplete = values.fechaInicioDevengue;
  let mounthDevengue = dateDevengueComplete.split("/")[1];
  let yearDevengue = dateDevengueComplete.split("/")[2];
  let dateDevengue = `01/${mounthDevengue}/${yearDevengue}`;
  let modifyBh = values.birthday.split("/");

  let newBh = `${modifyBh[1]}/${modifyBh[0]}/${modifyBh[2]}`;
  let data = {
    producto: {
      CodProducto: invesment.RENTA_GARANTIZADA,
      idVendedor: values.idUser,
      canal: invesment.CANAL,
      moneda: values.money_rg,
      idProspecto: values.idProspecto,
    },
    datosParticulares: [
      {
        nombre: "prima",
        valor: values.capital,
      },
      {
        nombre: "anios_temporal",
        valor: values.temporalYears ? parseInt(values.temporalYears.toString()) : 0,
      },
      {
        nombre: "fechaInicioDevengue",
        valor: dateDevengue,
      },
      {
        nombre: "asesor",
        valor: values.idUser,
      },
      {
        nombre: "cliente",
        valor: values.nroDoc.toString(),
      },
      {
        nombre: "fechaCalculo",
        valor: dateFormat,
      },
      {
        nombre: "fechaNacimiento",
        valor: newBh,
      },
      {
        nombre: "meses_diferimiento",
        valor: values.defermentMonths ? parseInt(values.defermentMonths.toString()) : 0,
      },
      {
        nombre: "meses_doblepago",
        valor: values.doublePaymentMonths ? parseInt(values.doublePaymentMonths.toString()) : 0,
      },
      {
        nombre: "moneda",
        valor: values.money_rg,
      },
      {
        nombre: "nrodocumento",
        valor: values.nroDoc.toString(),
      },
      {
        nombre: "periodo_pension",
        valor: values.pensionPeriod ?  parseInt(values.pensionPeriod) : 0,
      },
      {
        nombre: "plan",
        valor: values.planes ?  values.planes : 'PLAN_CON_DEVOLUCION_DE_PRIMA',
      },
      {
        nombre: "porcentaje_cesion_comision",
        valor: parseInt(values.cesion_comision.toString()),
      },
      {
        nombre: "porcentaje_devolucion",
        valor: values.premiumRefund ? parseInt(values.premiumRefund.toString()) : 0,
      },
      {
        nombre: "ajuste_pension",
        valor: /true/i.test(values.ajuste_pension),
      },
      {
        nombre: "monto_sepelio",
        valor: values.montoSepelio === "true" ? true : false,
      },
      {
        nombre: "sexo",
        valor: values.sexo,
      },
      {
        nombre: "tipodocumento",
        valor: parseInt(values.typeDoc),
      },
      {
        nombre: "nombreCliente",
        valor: (
          values.names +
          " " +
          values.firstName +
          " " +
          values.lastName
        ).toUpperCase(),
      },
      {
        nombre: "canal",
        valor: values.channel,
      },
      {
        nombre: "fnacimiento",
        valor: values.birthday,
      },
      {
        nombre: "nombresCliente",
        valor: values.names.toUpperCase(),
      },
      {
        nombre: "apePaternoCliente",
        valor: values.firstName.toUpperCase(),
      },
      {
        nombre: "apeMaternoCliente",
        valor: values.lastName.toUpperCase(),
      },
      {
        nombre: "anios_client",
        valor: age,
      },
      {
        nombre: "oportunidad",
        valor: values.oportunidad,
      },
      {
        nombre: "correo",
        valor: values.email,
      },
      {
        nombre: "celular",
        valor: values.phone,
      },
      {
        nombre: "dpsAfirmativa",
        valor: values.dpsAfirma == "true" ? true : false,
      },
      {
        nombre: "isSmoker",
        valor: values.isSmoker == "true" ? true : false
      },
      {
        nombre: 'capitalFallecimiento',
        valor: values.capitalFallecimiento ? values.capitalFallecimiento : 0 
      },
      {
        nombre: 'capitalSupervivencia',
        valor: values.capitalSupervivencia ? values.capitalSupervivencia : 0 
      },
      {
        nombre: 'contractorType',
        valor: repLegal && Object.keys(repLegal).length > 0 ? 'JURIDICO' : 'NATURAL'
      }
    ],
    datosAsegurado:  {
      ...assured
    },
     datosContratante: {
      ...contratant
     },
     datosRepLegal : {
      ...repLegal
     },
    ideTransaccion: uuid
  };
  let myInit = {
    body: data,
    headers: {},
  };

  return myInit;
};

export const awsApiCotizacionRI = (values) => {
  const age = moment().diff(moment(values.birthday, "DD/MM/YYYY"), "years");
  const data = {
    producto: {
      CodProducto: invesment.RENTA_INVERSION,
      idVendedor: values.idUser,
      canal: invesment.CANAL,
      moneda: "USD",
      idProspecto: values.idProspecto,
    },
    datosParticulares: [
      {
        nombre: "prima",
        valor: values.capital,
      },
      {
        nombre: "nombreCliente",
        valor: (
          values.names +
          " " +
          values.firstName +
          " " +
          values.lastName
        ).toUpperCase(),
      },
      {
        nombre: "code",
        valor: values.codigo,
      },
      {
        nombre: "nrodocumento",
        valor: values.nroDoc.toString(),
      },
      {
        nombre: "canal",
        valor: values.channel,
      },
      {
        nombre: "temporalYears",
        valor: parseInt(values.temporalYears),
      },
      {
        nombre: "birthday",
        valor: values.birthday.split("/").reverse().join("-"),
      },
      {
        nombre: "dps",
        valor: /true/i.test(values.dps),
      },
      {
        nombre: "nombresCliente",
        valor: values.names.toUpperCase(),
      },
      {
        nombre: "apePaternoCliente",
        valor: values.firstName.toUpperCase(),
      },
      {
        nombre: "apeMaternoCliente",
        valor: values.lastName.toUpperCase(),
      },
      {
        nombre: "fnacimiento",
        valor: values.birthday,
      },
      {
        nombre: "anios_client",
        valor: age,
      },
      {
        nombre: "oportunidad",
        valor: values.oportunidad,
      },
    ],
  };

  let myInit = {
    body: data,
    headers: {},
  };

  return myInit;
};

export const awsApiCotizacionVas = (values) => {
  const age = moment().diff(moment(values.birthday, "DD/MM/YYYY"), "years");
  let dateNow = moment().format("DD/MM/YYYY");

  let data = {
    producto: {
      CodProducto: "AS",
      idVendedor: values.idUser,
      canal: "web",
      moneda: values.money_vas,
      originLead: values.originLead,
      idProspecto: values.idProspecto,
    },
    datosParticulares: [
      {
        nombre: "prima",
        valor: values.capital,
      },
      {
        nombre: "typeDoc",
        valor: parseInt(values.typeDoc),
      },
      {
        nombre: "nombreCliente",
        valor: (
          values.names +
          " " +
          values.firstName +
          " " +
          values.lastName
        ).toUpperCase(),
      },
      {
        nombre: "fechaCalculo",
        valor: dateNow,
      },
      {
        nombre: "asesor",
        valor: values.idUser,
      },
      {
        nombre: "nrodocumento",
        valor: values.nroDoc,
      },
      {
        nombre: "anios",
        valor:
          parseInt(values.years) === 6 && values.years.includes("meses")
            ? 0.5
            : parseInt(values.years),
      },
      {
        nombre: "dpsAfirmativa",
        valor: /true/i.test(values.dps),
      },
      {
        nombre: "canal",
        valor: values.channel,
      },
      {
        nombre: "fnacimiento",
        valor: values.birthday,
      },
      {
        nombre: "codePlan",
        valor: values.isAditionalsTopping ? "004" : "003",
      },
      {
        nombre: "isAditionalsTopping",
        valor: values.isAditionalsTopping,
      },
      {
        nombre: "nombresCliente",
        valor: values.names.toUpperCase(),
      },
      {
        nombre: "apePaternoCliente",
        valor: values.firstName.toUpperCase(),
      },
      {
        nombre: "apeMaternoCliente",
        valor: values.lastName.toUpperCase(),
      },
      {
        nombre: "sexo",
        valor: values.sexo
      },
      {
        nombre: "anios_client",
        valor: age,
      },
      {
        nombre: "oportunidad",
        valor: values.oportunidad,
      },
      {
        nombre: "porcentaje_cesion_comision",
        valor: values.percentCommission,
      },
      {
        nombre: "penalidad",
        valor: values.penalty,
      },
      {
        nombre: "correo",
        valor: values.email,
      },
      {
        nombre: "celular",
        valor: values.phone,
      },
    ],
  };

  let myInit = {
    body: data,
    headers: {},
  };

  return myInit;
};

export const awsApiCotizacionIg = (values, assured, contratant, uuid) => {
  const dateNow = moment().format("DD/MM/YYYY");
  const age = moment().diff(moment(values.birthday, "DD/MM/YYYY"), "years");
  const data = {
    producto: {
      CodProducto: "IG",
      idVendedor: values.idUser,
      canal: "web",
      moneda: values.typecurrency || values.money_ig || "USD",
      originLead: "",
      idProspecto: values.idProspecto,
    },
    datosParticulares: [
      {
        nombre: "prima",
        valor: values.capital,
      },
      {
        nombre: "typeDoc",
        valor: parseInt(values.typeDoc),
      },
      {
        nombre: "fechaCalculo",
        valor: dateNow,
      },
      {
        nombre: "asesor",
        valor: values.idUser,
      },
      {
        nombre: "nrodocumento",
        valor: values.nroDoc,
      },
      {
        nombre: "dpsAfirmativa",
        //valor: /true/i.test(values.dps),
        valor: values.dpsAfirma == "true" ? true : false,
      },
      {
        nombre: "canal",
        valor: values.channel,
      },
      {
        nombre: "fnacimiento",
        valor: values.birthday,
      },
      {
        nombre: "nombresCliente",
        valor: values.names.toUpperCase(),
      },
      {
        nombre: "apePaternoCliente",
        valor: values.firstName.toUpperCase(),
      },
      {
        nombre: "apeMaternoCliente",
        valor: values.lastName.toUpperCase(),
      },
      {
        nombre: "sexo",
        valor: values.sexo,
      },
      {
        nombre: "aniosTemp",
        valor: values.yearTemp,
      },
      {
        nombre: "oportunidad",
        valor: values.oportunidad,
      },
      {
        nombre: "nombreCliente",
        valor: (
          values.names +
          " " +
          values.firstName +
          " " +
          values.lastName
        ).toUpperCase(),
      },
      {
        nombre: "anios_client",
        valor: age,
      },
      {
        nombre: "codigoPortafolio",
        valor: values.codigoPortafolio,
      },
      {
        nombre: "correo",
        valor: values.email,
      },
      {
        nombre: "celular",
        valor: values.phone,
      },
    ],
    datosAsegurado:  {
      ...assured
    },
     datosContratante: {
      ...contratant
     },
    ideTransaccion: uuid
  };

  let myInit = {
    body: data,
    headers: {},
  };

  return myInit;
};

export const awsApiCotizacionUc = (values, assured, contratant, uuid) => {
  const dateNow = moment().format("DD/MM/YYYY");
  const age = moment().diff(moment(values.birthday, "DD/MM/YYYY"), "years");
  const data = {
    producto: {
      CodProducto: "UC",
      idVendedor: values.idUser,
      canal: "web",
      moneda: values.typecurrency || values.money_uc || "USD",
      originLead: "",
      idProspecto: values.idProspecto,
    },
    datosParticulares: [
      {
        nombre: "prima",
        valor: values.capital,
      },
      {
        nombre: "typeDoc",
        valor: parseInt(values.typeDoc),
      },
      {
        nombre: "fechaCalculo",
        valor: dateNow,
      },
      {
        nombre: "asesor",
        valor: values.idUser,
      },
      {
        nombre: "nrodocumento",
        valor: values.nroDoc,
      },
      {
        nombre: "dpsAfirmativa",
        //valor: /true/i.test(values.dps),
        valor: values.dpsAfirma == "true" ? true : false,
      },
      {
        nombre: "canal",
        valor: values.channel,
      },
      {
        nombre: "fnacimiento",
        valor: values.birthday,
      },
      {
        nombre: "nombresCliente",
        valor: values.names.toUpperCase(),
      },
      {
        nombre: "apePaternoCliente",
        valor: values.firstName.toUpperCase(),
      },
      {
        nombre: "apeMaternoCliente",
        valor: values.lastName.toUpperCase(),
      },
      {
        nombre: "sexo",
        valor: values.sexo,
      },
      {
        nombre: "aniosTemp",
        valor: values.yearTemp,
      },
      {
        nombre: "oportunidad",
        valor: values.oportunidad,
      },
      {
        nombre: "nombreCliente",
        valor: (
          values.names +
          " " +
          values.firstName +
          " " +
          values.lastName
        ).toUpperCase(),
      },
      {
        nombre: "anios_client",
        valor: age,
      },
      {
        nombre: "codigoPortafolio",
        valor: values.codigoPortafolio,
      },
      {
        nombre: "correo",
        valor: values.email,
      },
      {
        nombre: "celular",
        valor: values.phone,
      },
    ],
    datosAsegurado:  {
      ...assured
    },
     datosContratante: {
      ...contratant
     },
    ideTransaccion: uuid
  };

  let myInit = {
    body: data,
    headers: {},
  };

  return myInit;
};
